import {
  formatRequestTypeLabel,
  normalizeTypeAlias,
} from '@/modules/financialclose/utils/bulkUploadValidation';
import { INFORMATION_MANAGER_TYPE_OPTIONS } from '@/modules/financialclose/utils/constants';

/**
 * Icon + tooltip label for request types (shared config with Information Manager).
 * @param {string} type
 * @returns {{ icon: string, iconSize: number, label: string, normalizedType: string }|null}
 */
export function getRequestTypeDisplay(type) {
  const normalizedType = normalizeTypeAlias(type) || type || '';
  const option = INFORMATION_MANAGER_TYPE_OPTIONS.find((entry) => entry.value === normalizedType);

  if (!option?.icon) {
    return null;
  }

  return {
    icon: option.icon,
    iconSize: option.iconSize,
    label: formatRequestTypeLabel(type) || normalizedType,
    normalizedType,
  };
}

/**
 * Human-readable request type label (Written Response, File Upload, Link, etc.).
 * @param {string} type
 * @returns {string}
 */
export function getRequestTypeLabel(type) {
  return formatRequestTypeLabel(type) || type || 'Unknown';
}

/**
 * Convert old 'urgent' field to new 'priority' field for backward compatibility
 * @param {Object} data - The request data object
 * @returns {Object} - Data with priority field
 */
export function convertUrgentToPriority(data) {
  const converted = { ...data };
  
  // If priority already exists, use it
  if (converted.priority) {
    return converted;
  }
  
  // Convert old urgent field to priority
  if (converted.urgent === true) {
    converted.priority = "High";
  } else if (!converted.priority) {
    converted.priority = "Low";
  }
  
  return converted;
}
